"use strict";

var _objectWithoutProperties = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Image;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useLDflexValue = _interopRequireDefault(require("../hooks/useLDflexValue"));
/** Displays an image whose source is a Solid LDflex expression. */


function Image(_ref) {
  var src = _ref.src,
      defaultSrc = _ref.defaultSrc,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      props = _objectWithoutProperties(_ref, ["src", "defaultSrc", "children"]);

  src = (0, _useLDflexValue.default)(src) || defaultSrc;
  return src ? _react.default.createElement("img", (0, _extends2.default)({
    src: src,
    alt: ""
  }, props)) : children;
}